"use strict";

// References
var alt = require("../alt");
var BankOverloardActions = require("../actions/BankOverloardActions");

var bankOverloardStore = alt.createStore(class BankOverloardStore {
    // Data
    constructor() {
        this.bindActions(BankOverloardActions);

        this.text = "";
        this.isDocked = false;
    }

    // Functions
    onToggleDockedLeftNavClick() {
        this.isDocked = !this.isDocked;
    }
});

module.exports = bankOverloardStore;



// WEBPACK FOOTER //
// ./app/scripts/stores/BankOverloardStore.js